import React, { useContext } from 'react';
import { Button as InfoButton } from 'components/common/Button';
import {
  InfoContainer,
  InfoWrapper,
  InfoRow,
  ColumnOne,
  ColumnTwo,
  TextWrapper,
  TopLine,
  Heading,
  Subtitle,
  ButtonWrapper,
  ImageWrapper,
  Image
} from './features.styles';

import { MotionBox } from 'components/common/MotionBox';
import { IntersectionContext } from 'components/intersection-observer';
import { sectionVariants } from 'theme/motion.variants';

const Features = ({
  id,
  lightBg,
  lightText,
  imgStart,
  topLine,
  headline,
  darkText,
  description,
  buttonLabel,
  img,
  alt,
  primary,
  dark,
  dark2
}) => {
  const { inView } = useContext(IntersectionContext);

  return (
    <>
      <InfoContainer lightBg={lightBg} id={id}>
        <MotionBox
          initial="hidden"
          animate={inView ? 'visible' : 'hidden'}
          exit="hidden"
          variants={sectionVariants}
        >
          <InfoWrapper>
            <InfoRow imgStart={imgStart}>
              <ColumnOne>
                <TextWrapper>
                  <TopLine>{topLine}</TopLine>
                  <Heading lightText={lightText}>{headline}</Heading>
                  <Subtitle darkText={darkText}>{description}</Subtitle>
                  <ButtonWrapper>
                    <InfoButton
                      to="/"
                      primary={primary ? 1 : 0}
                      dark={dark ? 1 : 0}
                      dark2={dark2 ? 1 : 0}
                      smooth={true}
                      spy={true}
                      exact="true"
                      offset={-80}
                    >
                      {buttonLabel}
                    </InfoButton>
                  </ButtonWrapper>
                </TextWrapper>
              </ColumnOne>
              <ColumnTwo>
                <ImageWrapper>
                  <Image src={img} alt={alt} />
                </ImageWrapper>
              </ColumnTwo>
            </InfoRow>
          </InfoWrapper>
        </MotionBox>
      </InfoContainer>
    </>
  );
};

export default Features;
